import { ID } from '@griply/types';

export const getLifeAreaGoalIds = (
  lifeAreaIds: ID[],
  lifeAreaGoalIdsMap?: Map<ID, ID[]>,
): ID[] => {
  if (!lifeAreaIds.length || !lifeAreaGoalIdsMap) {
    return [];
  }

  return lifeAreaIds.flatMap(
    (lifeAreaId) => lifeAreaGoalIdsMap.get(lifeAreaId) ?? [],
  );
};
